import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getApiRequest } from '../../services/getApiRequest';

// Thunk to fetch loyalty points
const getLoyaltyPointsSession = createAsyncThunk(
    'api/Offer/GetLoyaltySession',
    async (_, { rejectWithValue, dispatch }) => {
        try {
            const ApiRequest = getApiRequest();
            const searchParams = new URLSearchParams(window.location.search);
            const searchId = searchParams.get('SearchId');

            if (!searchId) {
                return rejectWithValue("SearchId is missing in URL.");
            }

            const response = await ApiRequest({
                url: "Offer/GetLoyaltySession",
                method: "post",
                data: { searchId }
            });

            if (response.status === 200 && response.data?.data) {
                return response.data.data;
            } else {
                throw new Error("Invalid response data.");
            }
        } catch (error) {
            console.error("Error fetching loyalty points:", error);
            return rejectWithValue(error.message || "Failed to fetch loyalty points.");
        }
    }
);

// Slice for loyalty points data
const loyaltyPointsData = createSlice({
    name: 'loyaltyPoints',
    initialState: {
        isLoyaltyApplied: false,
        loyaltyValue: 0,
        loyaltyPoints: 0,
        isLoading: false,
        error: null
    },
    reducers: {
        setLoyaltyPointsData: (state, action) => {
            if (action.payload) {
                
                state.isLoading = false;
                state.loyaltyValue = action.payload?.LoyaltyFareDetails?.RedeemValue || 0;
                state.loyaltyPointsRedeemed = action.payload?.LoyaltyFareDetails?.RedeemPoints || 0;
                state.isLoyaltyApplied = action.payload.Status === "Applied";
                state.error = null;
            } else {
                state.isLoading = false;
                state.loyaltyValue = 0;
                state.loyaltyPointsRedeemed = 0;
                state.isLoyaltyApplied = false;
                state.error = null;
            }
            state.isLoading = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLoyaltyPointsSession.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getLoyaltyPointsSession.fulfilled, (state, action) => {
                state.isLoading = false;
                state.loyaltyValue = action.payload?.LoyaltyFareDetails?.RedeemValue || 0;
                state.loyaltyPointsRedeemed = action.payload?.LoyaltyFareDetails?.RedeemPoints || 0;
                state.isLoyaltyApplied = action.payload.Status === "Applied";
                state.error = null;
            })
            .addCase(getLoyaltyPointsSession.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Error fetching loyalty points.";
            });
    }
});

export const { setLoyaltyPointsData } = loyaltyPointsData.actions;
export { getLoyaltyPointsSession };
export default loyaltyPointsData.reducer;
